.panel {
	background: var(--surface-card);
	border-radius: var(--radius-lg);
	padding: var(--space-5);
	display: flex;
	flex-direction: column;
	gap: var(--space-4);
	max-height: var(--dialog-max-h);
	overflow-y: auto;
}

.heading {
	margin: 0;
	font-size: 1rem;
	font-weight: 600;
	color: var(--ink-muted);
	text-transform: uppercase;
	letter-spacing: 0.04em;
}

.field {
	display: flex;
	flex-direction: column;
	gap: var(--space-2);
}

.label {
	font-size: 0.75rem;
	font-weight: 600;
	color: var(--ink-muted);
	text-transform: uppercase;
	letter-spacing: 0.04em;
}

.input {
	width: 100%;
	padding: var(--space-3);
	border: 1px solid color-mix(in srgb, var(--ink) 12%, transparent);
	border-radius: var(--radius-md);
	background: var(--surface-input);
	color: var(--ink);
	font: inherit;
}

.input:focus {
	outline: 2px solid var(--accent-sage);
	outline-offset: 1px;
}

.segmented {
	display: flex;
	gap: 0;
	border: 1px solid color-mix(in srgb, var(--ink) 12%, transparent);
	border-radius: var(--radius-md);
	overflow: hidden;
}

.segment {
	flex: 1;
	padding: var(--space-3);
	background: var(--surface-input);
	border: none;
	color: var(--ink);
	font: inherit;
	cursor: pointer;
	transition: background 0.1s ease;
}

.segment + .segment {
	border-left: 1px solid color-mix(in srgb, var(--ink) 12%, transparent);
}

.segment:hover:not(:disabled):not(.segmentActive) {
	background: color-mix(in srgb, var(--accent-sage) 8%, var(--surface-input));
}

.segmentActive {
	background: color-mix(
		in srgb,
		var(--accent-sage) 20%,
		var(--surface-input)
	);
	font-weight: 600;
}

.segment:disabled {
	opacity: 0.45;
	cursor: not-allowed;
}

.hint {
	margin: 0;
	font-size: 0.8rem;
	color: var(--ink-muted);
}

.results {
	list-style: none;
	margin: 0;
	padding: 0;
	display: flex;
	flex-direction: column;
	gap: 2px;
	max-height: 220px;
	overflow-y: auto;
	border: 1px solid color-mix(in srgb, var(--ink) 10%, transparent);
	border-radius: var(--radius-md);
	background: var(--surface-input);
}

.result {
	display: block;
	width: 100%;
	padding: var(--space-2) var(--space-3);
	background: transparent;
	border: none;
	color: var(--ink);
	font: inherit;
	font-size: 0.85rem;
	text-align: left;
	cursor: pointer;
	line-height: 1.4;
}

.result:hover {
	background: color-mix(in srgb, var(--accent-sage) 12%, transparent);
}

.mapInDialog {
	height: 180px;
}

.error {
	margin: 0;
	padding: var(--space-2) var(--space-3);
	background: color-mix(in srgb, var(--accent-rose) 14%, var(--surface-card));
	border-radius: var(--radius-sm);
	color: var(--ink);
	font-size: 0.85rem;
}

.actions {
	display: flex;
	justify-content: flex-end;
	gap: var(--space-2);
}

.cancel {
	padding: var(--space-2) var(--space-4);
	background: transparent;
	border: 1px solid color-mix(in srgb, var(--ink) 18%, transparent);
	border-radius: var(--radius-md);
	color: var(--ink);
	font: inherit;
	cursor: pointer;
}

.submit {
	padding: var(--space-2) var(--space-4);
	background: var(--accent-sage);
	border: none;
	border-radius: var(--radius-md);
	color: #fff;
	font: inherit;
	font-weight: 600;
	cursor: pointer;
}

.submit:disabled {
	opacity: 0.5;
	cursor: not-allowed;
}
